import { Component, h, Fragment } from 'preact';

import { BookingState, connectStore } from '../../store';
import { getKey, Key, LocationType, Properties, WidgetTab } from '../../common';
import Selector from '../../common/Selector/Selector';
import { WithStyles, withStyles } from '../../style';
import { isPresent } from '../../utils';
import * as appStyles from '../BookingWidget.scss';
import * as styles from './LocationSelectorBase.scss';
import { LocationItem } from './LocationModal/LocationResult/LocationResult';
import { getLang } from '../../i18n/getLang';
import { LocationCode } from './LocationModal/LocationCode/LocationCode';

export interface LocationSelectorBaseProps extends Properties {
  locationType: LocationType;
  text: string | JSX.Element;
  onSelect: () => void;
  location?: LocationItem;
  enableCompactWidget: boolean;
}
interface StoreProps {
  locale: string;
  onAmTab: boolean;
}

type EffectiveProps = LocationSelectorBaseProps & StoreProps & WithStyles;

/** big font lang max visile name length is 10
 *  rest of the font, max visible length is 18
 */

const MAX_NAME_LENGTH_BIG_FONT = 10;
const MAX_NAME_LENGTH_NORMAL_FONT = 18;
const BIG_FONT_LANG = ['ja', 'zh'];
const mapStateToProps = ({ selection: { locale }, currentTab }: BookingState): StoreProps => ({
  locale,
  onAmTab: currentTab === WidgetTab.AM,
});

@connectStore({ mapStateToProps })
@withStyles(appStyles, styles)
export default class LocationSelectorBase extends Component<LocationSelectorBaseProps> {
  handleKeyUp = (e: KeyboardEvent): void => {
    const key: Key = getKey(e);
    if (key === Key.ENTER || key === Key.SPACE) {
      this.props.onSelect();
    }
  };

  render({
    locationType,
    text,
    onSelect,
    location,
    tx,
    enableCompactWidget,
    locale,
    onAmTab,
  }: EffectiveProps): h.JSX.Element {
    const typeStyle = locationType === LocationType.DESTINATION ? 'bw-destination destination' : 'bw-origin origin';
    const maxTitleLength = BIG_FONT_LANG.some((lang) => lang === getLang(locale))
      ? MAX_NAME_LENGTH_BIG_FONT
      : MAX_NAME_LENGTH_NORMAL_FONT;
    return (
      <Selector class={tx(`contentItem ${typeStyle}`)} onClick={onSelect} onKeyUp={this.handleKeyUp}>
        <div class="grey-600-text font-body-1">{text}</div>
        {isPresent(location) && (
          <div class="nordic-blue-900-text medium-type font-heading-5 flex">
            {enableCompactWidget && location.title && location.title.length > maxTitleLength ? (
              <div class={tx('locationTitle overflow-hidden truncate')}>{location.title}</div>
            ) : (
              <Fragment>{location.title}</Fragment>
            )}
            {enableCompactWidget && !onAmTab && (
              <div class={tx('airportCode')}>
                <LocationCode
                  type={location?.type}
                  locationCode={location?.locationCode}
                  enableCompactWidget={enableCompactWidget}
                />
              </div>
            )}
          </div>
        )}
        {isPresent(location) && !enableCompactWidget && (
          <div class="nordic-blue-900-text font-body-1 truncate overflow-hidden">
            {isPresent(location?.locationCode) && `${location?.locationCode}, `}
            {location.subtitle}
          </div>
        )}
      </Selector>
    );
  }
}
